import Vue, { PropType } from 'vue';

import { KeystrokeInputableTextId } from '@/components/keystrokeInputableText/KeystrokeInputableText';

export default Vue.extend({
  name: 'KeystrokePropsMixin',

  props: {
    // 各「KeystrokeInputableText」の一意のid
    id: {
      type: Object as PropType<KeystrokeInputableTextId>,
      required: true,
    },
    // idの二次元配列
    // ※移動対象である全「KeystrokeInputableText」のidを設定する（ [[rowIds], [rowIds], [rowIds], ...] のようなイメージ）
    // ※入力可能であるセルが存在する行/列のみmapに設定する
    // ※各配列の要素数はそれぞれ同じ数とし、移動不要であるセルはnullとする
    map: {
      type: Array as PropType<(KeystrokeInputableTextId | null)[][]>,
      required: true,
    },
  },
});
